import { FuseAnimate } from '@fuse';
import _ from '@lodash';
import { Typography, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import withReducer from 'app/store/withReducer';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import MeusConvitesCard from './MeusConvitesCard';
import * as Actions from './Store/Actions/MeusConvitesActions';
import reducer from './Store/Reducers/MeusConvitesReducer';

const styles = theme => ({
    button: {
        color: theme.palette.text.primary,
    }
});

class MeusConvitesApp extends XAPPComponent {

    componentDidMount() {
        const { list, idpessoa } = this.props;
        list(idpessoa);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.MeusConvites.error) {
            this.props.showMessage({
                message: this.props.MeusConvites.error,
                variant: 'error'
            });
            this.props.MeusConvites.error = null;
        }
        if (this.props.MeusConvites.warning) {
            this.props.showMessage({
                message: this.props.MeusConvites.warning,
                variant: 'warning'
            });
            this.props.MeusConvites.warning = null;
        }
        if (this.props.MeusConvites.info) {
            this.props.showMessage({
                message: this.props.MeusConvites.info,
                variant: 'success'
            });
            this.props.MeusConvites.info = null;
        }
    }

    render() {
        const { MeusConvites, idpessoa } = this.props;

        return (
            <div className="flex flex-col h-inherit">
                {!_.isNull(MeusConvites.data) ?
                    <React.Fragment>
                        {MeusConvites.data.map(item => (
                            <MeusConvitesCard
                                item={item}
                                idpessoa={idpessoa}
                            />
                        ))}
                    </React.Fragment>
                    :
                    <div className="h-full items-center">
                        <FuseAnimate delay={100}>
                            <div className="flex flex-1 items-center justify-center h-full">
                                <Typography color="textSecondary" variant="h6">
                                    Não existem registros cadastrados!
                                </Typography>

                            </div>
                        </FuseAnimate>
                    </div>
                }
            </div>
        )
    };
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ MeusConvites }) {
    return {
        MeusConvites: MeusConvites,
    }
}

export default withReducer('MeusConvites', reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(MeusConvitesApp))));
